/* unplugin-vue-components disabled */import { render } from "./privacyPolicyEN.vue?vue&type=template&id=eae202ac&scoped=true"
import script from "./privacyPolicyEN.vue?vue&type=script&lang=js"
export * from "./privacyPolicyEN.vue?vue&type=script&lang=js"

import "./privacyPolicyEN.vue?vue&type=style&index=0&id=eae202ac&scoped=true&lang=css"

import exportComponent from "E:\\IDEAWorkSpace\\parent-net-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eae202ac"]])

export default __exports__